<template>
  <div class="page-container onboarding-pdf">
    <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;700;900&amp;display=swap" rel="stylesheet">
    <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" rel="stylesheet">
    <!--<vx-tour :steps="steps" :active="InTour" @TourCompleted="UpdateUserPrefsForTour('none')" @TourStopped="InTour = false" @TourStarted="InTour = true" />-->
    <vs-popup :title="$t('OnboardingProperties')" :active.sync="InPropertiesMenu" v-if="InPropertiesMenu">
      <TabContainer :onboarding="CurrentOnboarding"></TabContainer>
    </vs-popup>

    <div v-if="allowCompleteButton">
      <transition name="fade">
        <vs-button @click="HandleMarkCompletion"
                   style="z-index:9999"
                   ref="markAsCompletedButton"
                   color="success" id="btn-complete"
                   class="fixed bottom-0 right-0 mr-5 mb-5">
          {{$t('MarkAsComplete')}}
        </vs-button>
      </transition>
    </div>

    <vs-popup :title="$t('Fullscreen')" fullscreen v-if="InCodeFullsceenMode" :active.sync="InCodeFullsceenMode">
      <MonacoEditor :suffix="fullscreen" :theme="vs-light" :text_value="currentCode"></MonacoEditor>
    </vs-popup>

    <vs-popup :title="$t('VerifyYourEmail')" v-if="InAnonymousEmailInputMode" :active.sync="InAnonymousEmailInputMode">
      <VerifyAnonymousEmail @anon-verified="handleAnonymousEmailVerification"></VerifyAnonymousEmail>
    </vs-popup>

    <vs-popup :title="$t('Verification')" :active.sync="InAuthorizationMode" v-if="InAuthorizationMode">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mb-base">
          {{$t('WeHaveJustSentEmailWithPin')}}
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                    :label-placeholder="$t('Code') + ':'"
                    v-model="password" />
        </div>
      </div>
      {{$t('DidntReceiveCode')}} <a class="pointer" @click="ResendEmail">{{$t('ClickHereToResend')}}</a>
      <div>
        <a v-if="isKnownUser" class="pointer" @click="sendLoginLink">{{$t('ClickHereToLogin')}}</a>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vs-button @click="ValidatePIN(password)">{{$t('Validate')}}</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup class="mt-8" :title="$t('ImageZoom')" fullscreen :active.sync="CanClose" v-if="InImageZoom">
      <ImageEditor :base64Image="CurrentZoomImage" @StateChanged="HasImageChanges" @ImageSave="ImageSaved">

      </ImageEditor>
    </vs-popup>
    <div class="sop-container" v-if="!showSlideshow" :style="{ display: IsLoading ? 'none' : '' }">
      <a href="javascript:history.back(-1)" onclick="" class="no-print back-btn" v-if="!showSlideshow"><<</a>
      <div class="menu-container no-print">

        <!-- Mode Toggle - Hidden for now -->
        <!-- <div class="mode-toggle no-print" style="float:left; margin-right: 20px;">
          <vs-button-group>
            <vs-button
              :color="!presentationMode ? 'primary' : 'default'"
              @click="switchToPDFMode"
              size="small">
              PDF Mode
            </vs-button>
            <vs-button
              :color="presentationMode ? 'primary' : 'default'"
              @click="switchToPresentationMode"
              size="small">
              Presentation Mode
            </vs-button>
          </vs-button-group>
        </div> -->

        <div class="menu-controls" style="float:right;">
          <!-- Fullscreen Button for PDF Mode -->
          <button class="control-btn fullscreen-btn no-print"
                  @click="toggleFullscreen"
                  :title="$t('ToggleFullscreen')"
                  style="margin-right: 10px;">
            <i :class="isFullscreen ? 'fas fa-compress' : 'fas fa-expand'" style="color: black;"></i>
          </button>

            <vs-dropdown id="menu-dropdown"  vs-trigger-click class="pointer" >
              <FeatherIcon class="tool pointer" :title="$t('Options')" icon="MenuIcon" style="position:unset; cursor:pointer;"></FeatherIcon>
              <vs-dropdown-menu>
                <vs-dropdown-item v-if="$acl.check('admin')" @click="OpenShareOnboarding">{{$t('ShareOnboarding')}}</vs-dropdown-item>
                <vs-dropdown-item @click="switchToSlideshowMode">{{$t('ViewAsSlideshow')}}</vs-dropdown-item>
                <vs-dropdown-item @click="HandleMarkCompletion"> {{$t('MarkAsComplete')}}</vs-dropdown-item>
                <vs-dropdown-item v-if="$acl.check('admin')" @click="GoToAnalytics">{{$t('Analytics')}}</vs-dropdown-item>
                <vs-dropdown-item v-if="$acl.check('admin') && $route.query.oid" @click="GoToEditor">{{$t('Edit')}}</vs-dropdown-item>
                <!--<vs-dropdown-item @click="ShowTour">Display tour</vs-dropdown-item>-->
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>

      <div class="side-kick" v-if="false">
        <img src="@/assets/images/logo/logo.png" />
        <div class="built-with">
          {{$t('RecordedWith')}} <strong>TCVelik</strong>
        </div>
      </div>
      <div class="sop-header">
        <h1 v-if="CurrentOnboarding && CurrentOnboarding.name" class="">
          {{CurrentOnboarding.name}}
        </h1>
      </div>
      <div v-if="CurrentOnboarding && CurrentOnboarding.description" class="description">
        <p>{{CurrentOnboarding.description}}</p>
      </div>

      <div class="print-content" ref="contentholder">
        <!-- Content will be rendered here based on mode -->
      </div>
    </div>

    <!-- Slideshow Component - Outside sop-container -->
    <OnboardingSlideshow v-if="showSlideshow"
                         :onboardingData="slideshowData"
                         :autoPlay="false"
                         :autoPlayDelay="5000"
                         @exit-presentation="exitSlideshow"
                         @open-code-fullscreencomplete="OpenPresentationCodeInFullscreen"
                         @slide-change="onSlideChange"
                         @presentation-complete="onPresentationComplete" />
    <vs-popup :title="$t('ShareOnboarding')" style="" :active.sync="InShareOnboardingMode" class="share-onboarding-popup" v-if="InShareOnboardingMode">
      <ShareComponent :shareObjectType="'0'" :shareObjectId="this.$route.query.oid"></ShareComponent>
    </vs-popup>

    <vs-popup :title="$t('FeedbackTitle')" :active.sync="InFeedbackMode" v-if="InFeedbackMode">
      <FeedbackCard @CloseFeedback="CloseFeedbackMenu" :shareObjectId="this.$route.query.oid"></FeedbackCard>
    </vs-popup>

    <vs-popup :title="$t('AssignOnboarding')" :active.sync="InAssignOnboardingMode" v-if="InAssignOnboardingMode">
      <AssignComponent :shareObjectType="'0'" :shareObjectId="this.$route.query.oid"></AssignComponent>
    </vs-popup>

    <vs-popup :title="$t('AssignOnboarding')" :active.sync="InAssignToRoleMode" v-if="InAssignToRoleMode">
      <AssignComponent :shareObjectType="'0'" :shareObjectId="this.$route.query.oid"></AssignComponent>
    </vs-popup>

    <vs-popup :title="$t('VerificationCode')" :active.sync="InEmailInputMode" v-if="InEmailInputMode">
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          {{$t('PleaseEnterYourEmailVerification')}}
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                    :label-placeholder="$t('EmailLabel')"
                    v-model="InputEmail" />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <vs-button @click="VerifyEmail(InputEmail)">{{$t('Send')}}</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup :title="$t('AddCommentToStep')" :active.sync="InAddingCommentToStepMode" v-if="InAddingCommentToStepMode">
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          {{$t('Comment')}}:
          <vs-textarea class="vx-col w-1/1 lg:w-1/1" height='200px' style="width:100%;"
                       :label-placeholder="$t('Comment') + ':'"
                       v-model="stepComment" />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vs-button @click="AddCommentToStep(stepComment)">{{$t('Add')}}</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup :title="$t('AddOnboardingToSpaceTitle')" :active.sync="InAddOnboardingToSpaceMode" v-if="InAddOnboardingToSpaceMode">
      <div style="min-height:200px" class="vx-col mt-3">
        <v-select multiple
                  label="breadcrumbTile"
                  :closeOnSelect="false"
                  v-model="onboardingSpaces"
                  push-tags
                  :options="Spaces" />
      </div>

    </vs-popup>
  </div>
  </div>
</template>

<script>
  import { AclRule } from 'vue-acl'
  import Vue from "vue";
  import { ref } from 'vue'
  import TabContainer from '@/views/ui-elements/tabs/TabContainer.vue'
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import accountsService from '@/accounts/accountsService';
  import ImageEditor from '@/views/components/extra-components/imageeditor/ImageEditor.vue';
  import DeleteOnboardingLink from '@/views/components/atoms/onboardings/DeleteOnboardingLink'
  import FeedbackCard from '@/views/feedback/FeedbackCard'
  import ShareComponent from '@/views/components/extra-components/share/ShareComponent.vue';
  import VerifyAnonymousEmail from '@/components/VerifyAnonymousEmail.vue'
  import AssignComponent from '@/views/components/extra-components/assign/AssignComponent.vue';
  import MonacoEditor from '@/views/components/extra-components/editors/MonacoEditor.vue';
  import FeatherIcon from "@/components/FeatherIcon.vue";
  import AccountService from "@/accounts/accountsService.js";
  import vSelect from "vue-select";
  import './OnboardingPDF.vue.css';
  import stepsData from './OnboardingPDF.vue.steps.js';
  const VxTour = () => import("@/components/VxTour.vue");
  import OnboardingSlideshow from '@/components/OnboardingSlideshow.vue';

  // Load standalone parsers
  if (typeof window !== 'undefined') {
    // Load from public folder
    const script1 = document.createElement('script');
    script1.src = '/onboarding-parser.js';
    script1.onload = () => {
      console.log('onboarding-parser.js loaded successfully');
      console.log('window.OnboardingParser available:', !!window.OnboardingParser);
    };
    script1.onerror = () => {
      console.error('Failed to load onboarding-parser.js');
    };
    document.head.appendChild(script1);
  }

  export default {
    data() {
      return {
        ShareType: "0",
        InImageZoom: false,
        InTour: false,
        CurrentZoomImage: '',
        CurrentImgDOM: null,
        InputEmail: "",
        InPropertiesMenu: false,
        onboardingLink: "",
        password: "",
        guestEmail: null,
        isKnownUser: false,
        currentCode: "",
        tempStepId: "",
        stepComment: "",
        selectedSpace: "",
        IsLoading: true,
        imageChanged: false,
        AfterShare: false,
        CurrentOnboarding: null,
        Spaces: null,
        tokenType: null,
        InFeedbackMode: false,
        onboardingSpaces: null,
        InShareOnboardingMode: false,
        InAddOnboardingToSpaceMode: false,
        InAddingCommentToStepMode: false,
        InCodeFullsceenMode: false,
        InAnonymousEmailInputMode: false,
        storedCompleteFn: null,
        storedCheckFn: null,
        InEmailInputMode: false,
        InDraftPage: false,
        InAssignOnboardingMode: false,
        InAuthorizationMode: false,
        FixedButtonVisible: true,
        CanShareOnboarding: false,
        GuestUserActions: false,
        tempSpaceList: [],
        AuthorizedUserActions: false,
        PDFDownloadRequestInProgress: false,
        InAssignToRoleMode: false,
        allowCompleteButton: false,
        shareReq: {
          onboardingId: this.CurrentOnboarding ? this.CurrentOnboarding.id : 0,
          email: '',
        },
        steps: stepsData.steps,

        // New presentation mode properties
        presentationMode: false,
        parser: null,
        parsedOnboardingData: null,
        showSlideshow: false,
        isFullscreen: false
      }
    },
    computed: {
      CanClose: {
        // getter
        get: function () {
          return this.InImageZoom
        },
        // setter
        set: function (newValue) {
          if (this.imageChanged) {
            if (confirm(this.$t('AreYouSureUnsavedChanges'))) {
              this.InImageZoom = newValue
              this.handleImageEditorClose()
            }
          }
          else {
            this.InImageZoom = newValue
            this.handleImageEditorClose()
          }
        }
      },

      slideshowData() {
        if (!this.parsedOnboardingData) {
          return {
            title: this.CurrentOnboarding?.name || this.$t('Untitled'),
            id: this.CurrentOnboarding?.id,
            title: this.CurrentOnboarding?.name || 'Untitled',
            description: this.CurrentOnboarding?.description || '',
            steps: []
          };
        }

        return {
          title: this.CurrentOnboarding?.name || 'Untitled',
          description: this.CurrentOnboarding?.description || '',
          steps: this.parsedOnboardingData.steps || []
        };
      }
    },
    watch: {
      'onboardingSpaces': function (newSpaces, oldSpaces) {
        if ((newSpaces != null && oldSpaces != null) && newSpaces.length > oldSpaces.length) {
          this.AddOnboardingToSpace(newSpaces.filter(x => !oldSpaces.includes(x)));
        }
        else if ((newSpaces != null && oldSpaces != null) && newSpaces.length < oldSpaces.length) {
          this.RemoveOnboardingFromSpace(oldSpaces.filter(x => !newSpaces.includes(x)));
        }
      },

      // Watch for route changes to handle mode switching
      '$route.query.mode': function (newMode) {
        const shouldBePresentationMode = newMode === 'slideshow';
        if (this.presentationMode !== shouldBePresentationMode) {
          this.presentationMode = shouldBePresentationMode;

          if (this.CurrentOnboarding) {
            if (shouldBePresentationMode) {
              this.showSlideshow = true;
            } else {
              this.showSlideshow = false;
            }
          }
        }
      },

      // Watch for preview parameter changes
      '$route.query.preview': function (newPreview) {
        if (newPreview === '1') {
          document.body.style.zoom = '65%';
        } else {
          document.body.style.zoom = '';
        }
      },

      // Watch for image editor open/close to handle scroll prevention
      'InImageZoom': function (newValue) {
        if (newValue) {
          this.handleImageEditorOpen()
        } else {
          this.handleImageEditorClose()
        }
      }
    },

    mounted() {

      document.querySelector("body").style.overflow = "hidden";

      // Initialize parser
      this.initializeParser();

      // Setup fullscreen detection
      this.setupFullscreenDetection();

      // Check for mode query parameter
      if (this.$route.query.mode === 'slideshow') {
        this.presentationMode = true;
      }

      // Check for preview query parameter
      if (this.$route.query.preview === '1') {
        document.body.style.zoom = '65%';
      }

      if (this.$route.query.oid) {
        this.IsLoading = true;
        if (accountsService.getUserFromLocalStorage() != null) {
          this.GuestUserActions = true;
          this.CanShareOnboarding = true;
          this.AuthorizedUserActions = true;
          if (this.$route.query.token != null) {
            this.AuthorizeLoggedInUser(this.$route.query.oid, this.$route.query.token)
          }
          else {
            this.LoadOnboarding()
            //this.LoadSpaces(0, "Spaces")
            this.LoadSpaces(this.$route.query.oid, "onboardingSpaces")
          }
        }
        else {
          if (this.$route.query.token != null) {
            // For shared links with tokens, authenticate as anonymous user first
            this.authenticateAsAnonymousUser().then(() => {
              this.IsSharedOnboarding(this.$route.query.oid, this.$route.query.token);
            });
          }
          else {
            // For anonymous users without tokens, try to load onboarding directly
            // This will work if the onboarding is assigned to the ANONYMOUS role
            this.authenticateAsAnonymousUser().then(() => {
              this.LoadOnboarding();
              this.LoadSpaces(this.$route.query.oid, "onboardingSpaces");
            }).catch((error) => {
              // If anonymous authentication fails, redirect to login
              document.location.href = "/pages/login?return=" + btoa(window.location.pathname + window.location.search) + "&error=" + encodeURIComponent("Anonymous authentication failed: " + (error.message || error));
            });
          }

        }
      }
      else if (this.$route.query.uniqueVersionId && accountsService.getUserFromLocalStorage() != null) {
        this.InDraftPage = true;
        this.LoadDraft();
      }
      else {
        this.Loading = false
      }
      this.checkForFeedbackQuery();
    },

    beforeDestroy() {
      // Clean up slideshow
      this.showSlideshow = false;

      // Clean up fullscreen event listeners
      this.cleanupFullscreenDetection();

      // Reset zoom if preview was applied
      if (this.$route.query.preview === '1') {
        document.body.style.zoom = '';
      }

      // Restore scroll if image editor was open
      if (this.InImageZoom) {
        this.handleImageEditorClose();
      }
    },
    methods: {

      async authenticateAsAnonymousUser() {
        // Call refreshUser to create an anonymous user session
        try {
          await AccountService.refreshUser();
          console.log('Authenticated as anonymous user for shared link access');
        } catch (error) {
          console.error('Failed to authenticate as anonymous user:', error);
          // Continue anyway - the user can still access the shared content
        }
      },

      async copyHtmlWithImages(bSkipImageConversion) {
        var instance = this;

        const element = document.querySelector(".page-container");
        if (!element) {
          return;
        }

        // Clone the element to avoid modifying the original
        let clonedElement = element.cloneNode(true);

        clonedElement.classList.add("copy-container")

        var titles = clonedElement.querySelectorAll("[data-type='draggable-item'] p:first-child");
        titles.forEach(p => {
          var newNode = document.createElement('h2');
          newNode.innerHTML = p.innerHTML;
          p.parentNode.replaceChild(newNode, p);
        });

        var allToRemove = clonedElement.querySelectorAll("[data-type='draggable-item'] p:last-of-type");
        allToRemove.forEach(p => {
          p.remove();
        });

        var allNoPrints = clonedElement.querySelectorAll(".no-print");
        allNoPrints.forEach(elmt => {
          elmt.remove();
        })

        // Make the title bigger
        var sopTitle = clonedElement.querySelector(".sop-header h1");
        if (sopTitle) {
          sopTitle.style.fontSize = "2.0em";
          sopTitle.style.color = "purple";
        }

        // Remove complete button
        var completeButton = clonedElement.querySelector("#btn-complete");
        if (completeButton) {
          completeButton.remove();
        }

        // Add watermark
        var watermark_container = document.createElement('div');
        var watermark = document.createElement('img');
        watermark.src = "/logo.png";

        var powered_by_text = document.createElement('p');
        powered_by_text.style.fontSize = "24px";
        powered_by_text.style.display = "inline-block";
        powered_by_text.innerHTML = "Powered by <strong>TCVelik</strong>";

        watermark_container.appendChild(watermark);
        watermark_container.appendChild(powered_by_text);
        clonedElement.appendChild(watermark_container);

        // Add link
        var link = document.createElement('a');
        link.href = window.location.href;
        link.innerHTML = instance.$t('ClickLinkBetterExperience');
        clonedElement.appendChild(link);

        // Convert images to Base64 and collect real Blobs
        const images = clonedElement.querySelectorAll("img");
        const blobs = [];

        if (!bSkipImageConversion) {
          for (let img of images) {
            if (img.src.startsWith("data:") || img.src.startsWith("blob:")) continue; // Already handled

            try {
              const response = await fetch(img.src);
              const blob = await response.blob();
              blobs.push(blob); // collect the blob

              const reader = new FileReader();
              reader.readAsDataURL(blob);
              await new Promise(resolve => {
                reader.onloadend = () => {
                  img.src = reader.result; // replace img with base64
                  resolve();
                };
              });
            } catch (error) {
              console.warn("Failed to convert image:", img.src, error);
            }
          }
        }
        // Prepare ClipboardItem
        const clipboardContent = {
          "text/html": new Blob([clonedElement.outerHTML], { type: "text/html" })
        };

        try {
          await navigator.clipboard.write([
            new ClipboardItem(clipboardContent)
          ]);
          instance.$vs.notify({
            title: instance.$t('SOPCopiedToClipboard'),
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        } catch (err) {
          console.error("Clipboard write failed", err);
          instance.$vs.notify({
            title: instance.$t('ErrorCopyingSOPToClipboard'),
            color: "error",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        }
      },

      handleAddLink({ url, text }) {
        this.GetEditorInsance()
          .chain()
          .insertContent(`<p><a target="_blank" rel="noopener noreferrer nofollow" href="${url}">${text}</a></p>`)
          .focus("end")
          .run();

        this.InAddLinkMode = false;
      },

      toggleComplete(which) {
        // Find the closest draggable item ancestor
        const draggableItem = which.closest("[data-type='draggable-item']");
        if (!draggableItem) {
          console.warn("Could not find draggable item ancestor");
          return;
        }

        // Get the step ID from the draggable item
        const stepId = draggableItem.dataset['stepId'];
        if (!stepId) {
          console.warn("Could not find step ID in draggable item");
          return;
        }

        if (draggableItem.classList.contains("completed")) {
          draggableItem.classList.remove("completed");
        } else {
          this.MarkStepAsComplete(null, stepId);
          draggableItem.classList.add("completed");
        }
      },
      toggleExpand(which) {
        var infoArea = which.parentElement
        if (infoArea.classList.contains("expanded")) {
          infoArea.classList.remove("expanded");
        }
        else {
          infoArea.classList.add("expanded");
        }
      },
      LoadOnboarding() {
        var instance = this;
        instance.$vs.loading()
        var id = this.$route.query.oid * 1;
        const query = `
                          query GetOnboardings($id: Int) {
                            onboardings(where: { id: {
                                  eq: $id
                              } }) {
                                  id
                                  name
                                  description
                                  rawContent,
                                  properties
                              }
                          }
                        `;

        const variables = {
          id: id
        };

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data && response.data.data.onboardings && response.data.data.onboardings.length > 0) {
            try {
              var onboarding = response.data.data.onboardings[0];
              var isExternal = false;
              if (onboarding.properties && onboarding.properties.length > 0) {
                var propsObj = JSON.parse(onboarding.properties);
                if (propsObj.ExternalUrl && propsObj.ExternalUrl.length > 0) {
                  isExternal = true;
                }
                instance.$refs.contentholder.id = "external-container"
                instance.$refs.contentholder.innerHTML = instance.$t('ExternalContentMessage') + "<br/><br/><br/><p class='' id='external-link'>" + propsObj.ExternalUrl + "</p><br/><a id='external-button' class='border-solid border-success rounded-lg border-2 bg-success text-white p-2' href='" + propsObj.ExternalUrl + "' target='_blank'>" + instance.$t('IUnderstandProceed') + "</a>"
              }
            }
            catch (err) {
            }

            if (!isExternal) {
              // Clean the raw content to remove any title/description that might be included
              let cleanContent = response.data.data.onboardings[0].rawContent;

              // Remove any h1 tags that might be the title (since we have our own title)
              cleanContent = cleanContent.replace(/<h1[^>]*>.*?<\/h1>/gi, '');

              // Remove any description paragraphs that might be at the top
              cleanContent = cleanContent.replace(/<p[^>]*class="[^"]*description[^"]*"[^>]*>.*?<\/p>/gi, '');

              instance.$refs.contentholder.innerHTML = cleanContent;
            }

            instance.shareReq.CurrentOnboarding = response.data.data.onboardings[0];
            instance.CurrentOnboarding = response.data.data.onboardings[0];

            // Parse onboarding data for presentation mode
            instance.parseOnboardingData(
              response.data.data.onboardings[0].rawContent,
              response.data.data.onboardings[0].properties
            );

            // Render appropriate mode based on query parameter
            if (instance.presentationMode) {
              instance.showSlideshow = true;
            } else {
              instance.RenderCodeStep();
            }

            document.title = instance.CurrentOnboarding.name;
            
            debugger;

            // Dispatch seoReady event for analytics tracking
            window.seoReady();
            
            instance.IsLoading = false;

            document.querySelector("body").style.overflow = "initial";

            instance.$vs.loading.close();

            var email = localStorage.getItem("pinUserEmail"); // if User with pin.
            if (!email || email.length == 0) {
              var email = JSON.parse(accountsService.getUserFromLocalStorage()).User.Email;
              var prefs = JSON.parse(accountsService.getUserFromLocalStorage()).UserPrefs;
            }

            TCVelikClient.PostRelative("/api/analytics/OpenedOnboarding?OnboardingId=" + variables.id + "&OnboardingType=0" + "&UserEmail=" + email);
            instance.$nextTick(function () {
              document.querySelectorAll("[data-type='draggable-item'] img")
                .forEach(function (image) {
                  image.classList.add("pointer");
                  image.dataset["url"] = image.src;
                  image.addEventListener('click', function () {
                    instance.CurrentZoomImage = image.src;
                    instance.CurrentImgDOM = image;
                    // Only allow image editing for non-guest roles
                    if (instance.$acl.check('editor') || instance.$acl.check('admin')) {
                      instance.InImageZoom = true;
                    } else {
                      // For guests, just show the image in a regular popup without editing capabilities
                      instance.$vs.notify({
                        title: instance.$t('ImageView'),
                        text: instance.$t('GuestUsersViewOnly'),
                        color: "warning",
                        iconPack: "feather",
                        position: "top-center",
                        icon: "icon-info",
                      });
                    }
                  });
                });

              // var tools = this.$refs.stepTools;

              // TODO: PEPI TO DOUBLE CHECK THIS!

              var step_complete_visibility = instance.checkForAnonymousCompletionBehavior(propsObj)

              document.querySelectorAll("[data-type='draggable-item'] p:first-of-type")
                .forEach(function (titleContainer) {
                  instance.createAndBindButtons(titleContainer, true, step_complete_visibility);
                  titleContainer.addEventListener("click", (e) => {
                    instance.toggleExpand(titleContainer);
                  })
                });

              document.querySelectorAll("[data-type='draggable-item'] p:nth-of-type(2)")
                .forEach(function (contentContainer) {
                  instance.createAndBindButtons(contentContainer, false, step_complete_visibility);
                });

              if (instance.$systemSettings && instance.$systemSettings.SopStepStateBehavior) {
                if (instance.$systemSettings.SopStepStateBehavior == "Expanded") {
                  document.querySelectorAll("[data-type='draggable-item']")
                    .forEach(function (contentContainer) {
                      contentContainer.classList.add("expanded")
                    });
                }
              }

              if (instance.$route.query.stepId) {
                var step = "[data-step-id='" + instance.$route.query.stepId + "']";
                var itemToScroll = document.querySelector(step);
                if (itemToScroll) {
                  window.setTimeout(function () {
                    itemToScroll.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    itemToScroll.classList.add("bg-warning");
                  }, 500);
                }
              }

              //if (Object.keys(prefs).length === 0 || prefs["DisplayOnboradingDetailsTour"] == null) {
              //  window.setTimeout(instance.ShowTour(), 5000);
              //}
            });
          }
          else {
            document.location.href = "/pages/not-authorized?returnUrl=" + window.location.href
          }
        }).catch(err => {
          document.location.href = "/pages/login?return=" + btoa(window.location.pathname + window.location.search) + "&error=" + encodeURIComponent("LoadOnboarding failed: " + (err.message || err))
        })
      },

      MarkStepAsComplete(event, stepId) {
        var instance = this;
        var email = accountsService.getUserObjectFromLocalStorageSafe().User.Email;
        TCVelikClient.PostRelative("/api/analytics/OnboardingStep/?OnboardingId=" + this.$route.query.oid + "&StepId=" + stepId + "&FeedbackType=" + 0 + "&UserEmail=" + email).then(function (response) {
          if (response) {
            instance.MarkOnboardingDoneIfNeeded();
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemCompletingStep'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      LoadDraft() {
        var instance = this;
        instance.$vs.loading()
        var id = this.$route.query.uniqueVersionId;
        var minorVersion = this.$route.query.minorVersion
        var majorVersion = this.$route.query.majorVersion
        if (minorVersion == null || majorVersion == null) {

        }
        var query = `
                    query OnboardingsVersion($uniqueVersionId:UUID) {
                        onboardingsVersion(where: {
                    uniqueVersionId: { eq: $uniqueVersionId }
                  } ) {
                        uniqueVersionId
                        name
                        rawContent
                        description
                        properties
                    }
              }
                  `;

        const variables = {
          uniqueVersionId: id
        };

        if (minorVersion != null || majorVersion != null) {
          query =
            variables["minorVersion"] = minorVersion * 1
          variables["majorVersion"] = majorVersion * 1

          query = `
               query OnboardingsVersion($uniqueVersionId:UUID,$minorVersion:Int,$majorVersion:Int) {
                   onboardingsVersion(where: {
               uniqueVersionId: { eq: $uniqueVersionId }
               majorVersion: { eq: $majorVersion }
               minorVersion: { eq: $minorVersion }
             } ) {
                   uniqueVersionId
                   name
                   rawContent
                   description
                   properties
               }
         }
             `;
        }

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data && response.data.data.onboardingsVersion && response.data.data.onboardingsVersion.length > 0) {
            try {
              var onboarding = response.data.data.onboardingsVersion[0];
              var isExternal = false;
              if (onboarding.properties && onboarding.properties.length > 0) {
                var propsObj = JSON.parse(onboarding.properties);
                instance.$refs.contentholder.id = "external-container"
                instance.$refs.contentholder.innerHTML = instance.$t('ExternalContentMessage') + "<br/><br/><br/><p class='' id='external-link'>" + propsObj.ExternalUrl + "</p><br/><a id='external-button' class='border-solid border-success rounded-lg border-2 bg-success text-white p-2' href='" + propsObj.ExternalUrl + "' target='_blank'>" + instance.$t('IUnderstandProceed') + "</a>"
              }
            }
            catch (err) {
            }

            instance.shareReq.CurrentOnboarding = response.data.data.onboardingsVersion[0];
            instance.CurrentOnboarding = response.data.data.onboardingsVersion[0];

            // Parse onboarding data for presentation mode
            instance.parseOnboardingData(
              response.data.data.onboardingsVersion[0].rawContent,
              response.data.data.onboardingsVersion[0].properties
            );

            // Render appropriate mode based on query parameter
            if (instance.presentationMode) {
              instance.showSlideshow = true;
            } else {
              instance.RenderCodeStep();

              // Clean the raw content to remove any title/description that might be included
              let cleanContent = response.data.data.onboardingsVersion[0].rawContent;

              // Remove any h1 tags that might be the title (since we have our own title)
              cleanContent = cleanContent.replace(/<h1[^>]*>.*?<\/h1>/gi, '');

              // Remove any description paragraphs that might be at the top
              cleanContent = cleanContent.replace(/<p[^>]*class="[^"]*description[^"]*"[^>]*>.*?<\/p>/gi, '');

              instance.$refs.contentholder.innerHTML = cleanContent;
            }

            document.title = instance.CurrentOnboarding.name;
            
            // Dispatch seoReady event for analytics tracking
            window.seoReady();

            document.querySelectorAll("[data-type='draggable-item'] p:first-of-type")
              .forEach(function (titleContainer) {
                instance.createAndBindButtons(titleContainer, true);
                instance.toggleExpand(titleContainer);
              });

            document.querySelectorAll("[data-type='draggable-item'] p:nth-of-type(2)")
              .forEach(function (contentContainer) {
                instance.createAndBindButtons(contentContainer, false);
              });

            document.querySelector("body").style.overflow = "initial";



            instance.IsLoading = false;
            instance.$vs.loading.close();

            var email = localStorage.getItem("pinUserEmail"); // if User with pin.
            if (!email || email.length == 0) {
              var email = JSON.parse(accountsService.getUserFromLocalStorage()).User.Email;
              var prefs = JSON.parse(accountsService.getUserFromLocalStorage()).UserPrefs;
            }
          }
          else {
            document.location.href = "/pages/not-authorized?returnUrl=" + window.location.href
          }
        }).catch(err => {
          document.location.href = "/pages/login?return=" + btoa(window.location.pathname + window.location.search) + "&error=" + encodeURIComponent("LoadDraft failed: " + (err.message || err))
        })
      },

      GetBreadcrumb(item) {
        if (item.parentId != null) {
          var parent = this.tempSpaceList.find(element => element.id === item.parentId);
          return this.GetBreadcrumb(parent) + " > " + item.title
        }
        else {
          return item.title
        }

      },

      CloseFeedbackMenu() {
        this.InFeedbackMode = false;
      },
      ShowToolsForStepTitle(title, tools) {
        title.appendChild(tools);

        tools.classList.remove("invisible");
        tools.style.top = 0;
        tools.style.right = 0;
      },
      RenderCodeStep() {
        try {
          var jsonObject = ''
          var codeSteps = document.querySelectorAll("[data-subtype='code']");
          const MonacoEditorCtor = Vue.extend(MonacoEditor);
          codeSteps.forEach((element, index) => {
            var code_data = element.querySelector('p:nth-of-type(3)').innerHTML
            var id = element.getAttribute('data-step-id');
            try {
              const match = code_data.match(/\{([^}]+)\}/);
              jsonObject = JSON.parse(match[0]);
              if (jsonObject.hasOwnProperty('Source')) {
                const vm = new MonacoEditorCtor({
                  propsData: {
                    suffix: index + "",
                    text_value: atob(jsonObject.Source),
                    readonly: true,
                    theme: "vs-light"
                  }
                })
                  .$mount(element.querySelector('p:nth-of-type(2)'));
                this.$refs[`monacoEditor${id}`] = vm;
              }
            } catch (e) {
              console.log(e)
            }
          });
        }
        catch (err) {
          console.error("Error rendering coded step.");
        }
      },

      AuthorizeLoggedInUser(targetObjectId, token) {
        var instance = this;
        instance.$vs.loading()
        TCVelikClient.PostRelative("/api/share/AuthorizeLoggedInUser/?targetObjectId=" + targetObjectId + "&token_id=" + token).then(function (response) {
          if (response) {
            instance.LoadOnboarding()
            instance.LoadSpaces(0, "Spaces")
            instance.LoadSpaces(instance.$route.query.oid, "onboardingSpaces")
          }
        }).catch(err => {
          instance.$vs.loading.close()
          document.location.href = "/pages/login?return=" + btoa(window) + "&error=" + encodeURIComponent("AuthorizeLoggedInUser failed: " + (err.message || err))
        });

      },

      GoToAnalytics() {
        const route = this.$router.resolve({ path: '/pages/analyticsOverview', query: { onboardingId: this.CurrentOnboarding.id } });
        window.open(route.href, '_blank')
      },


      GoToEditor() {
        const route = this.$router.resolve({ path: '/pages/record', query: { oid: this.CurrentOnboarding.id } });
        window.open(route.href, '_blank')
      },

      GoToLoginScreen() {
        document.location.href = "/pages/login?error=" + encodeURIComponent("GoToLoginScreen called");
      },
      ...stepsData.methods,
      IsSharedSpace(spaceId, token) {
        var instance = this;
        instance.$vs.loading()
        TCVelikClient.PostRelative("/api/share/IsSharedSpace?SpaceId=" + spaceId + "&token=" + token).then(function (response) {
          if (response) {
            if (response.data == 0) {
              instance.tokenType = 1;
              instance.ValidateToken(token, spaceId)
            }
            else {
              instance.InEmailInputMode = true;
              instance.$vs.loading.close()
            }
          }
          else if (token == undefined) {

            document.location.href = "/pages/login?return=" + btoa(window.location) + "&error=" + encodeURIComponent("IsSharedSpace: token is undefined")
          }
        }).catch(err => {
          document.location.href = "/pages/login?return=" + btoa(window.location) + "&error=" + encodeURIComponent("IsSharedSpace failed: " + (err.message || err))
        });

      },

      OpenAddOnboardingToSpaceMenu() {
        this.InAddOnboardingToSpaceMode = true;
      },

      HasImageChanges(isChanged) {
        this.imageChanged = isChanged;
      },

      IsSharedOnboarding(onboardingId, token) {
        var instance = this
        instance.$vs.loading()
        TCVelikClient.PostRelative("/api/share/IsSharedOnboarding?OnboardingId=" + onboardingId + "&token=" + token).then(function (response) {
          if (response) {
            if (response.data == 0) {
              // Email verification required (for ShareType 0, 1, or 2 with email verification enabled)
              instance.tokenType = 0;
              instance.$vs.loading.close()
              instance.InEmailInputMode = true; // Show email input first
            }
            else if (response.data == 2) {
              // Direct access allowed (ShareType 2 without email verification)
              instance.$vs.loading.close()
              instance.GuestUserActions = true;
              instance.CanShareOnboarding = true;
              instance.AuthorizedUserActions = true;
              instance.LoadOnboarding();
            }
            else {
              // Other share types (1, etc.) - show email input
              instance.$vs.loading.close()
              instance.InEmailInputMode = true;
            }
          }
          else if (token == undefined) {
            document.location.href = "/pages/login?error=" + encodeURIComponent("IsSharedOnboarding: token is undefined")
          }
        }).catch(err => {
          document.location.href = "/pages/login?error=" + encodeURIComponent("IsSharedOnboarding failed: " + (err.message || err))
        });
      },

      MarkAsCompletedForUser() {
        var instance = this;
        var email = localStorage.getItem("pinUserEmail"); // if User with pin.
        if (!email || email.length == 0) {
          var email = JSON.parse(accountsService.getUserFromLocalStorage()).User.Email;
        }

        TCVelikClient.PostRelative("/api/analytics/OpenedOnboarding?OnboardingId=" + this.CurrentOnboarding.id + "&OnboardingType=1" + "&UserEmail=" + email).then(function (response) {
          if (response) {
            instance.InFeedbackMode = true;
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemSavingOnboarding'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      VerifyEmail(email) {
        var instance = this
        TCVelikClient.PostRelative("/api/share/ConfirmTargetAudience?email=" + email + "&token=" + instance.$route.query.token).then(function (response) {
          if (response) {
            instance.InEmailInputMode = false;
            instance.ValidateToken(instance.$route.query.token, instance.$route.query.oid, email)
            instance.InAuthorizationMode = true;
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('NoAccessToResource'),
            text: instance.$t('NoAccessEmailMessage'),
            color: "warning",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
            time: 5000,
          });
        });
      },



      DownloadPDF(onboardingTitle) {
        var instance = this;
        if (instance.PDFDownloadRequestInProgress) {
          instance.$vs.notify({
            title: instance.$t('PageBeingConverted'),
            text: instance.$t('PleaseWait'),
            color: "warning",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
          return
        }
        instance.PDFDownloadRequestInProgress = true;
        TCVelikClient.PostRelative("/api/renderers/pdf?printUrl=" + window.location.href,
          {
            responseType: 'blob',
            fullUserInfo: accountsService.getUserFromLocalStorage()
          }
        ).then(function (response) {
          if (response && response.data) {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.download = `${onboardingTitle}.pdf`;
            link.href = URL.createObjectURL(blob);
            link.click();
            instance.PDFDownloadRequestInProgress = false;
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemConvertingToPDF'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      ValidateToken(token, onboardingId, email) {
        var instance = this
        if (token == undefined) {
          alert(instance.$t('PageCannotBeAccessed'))
          return;

        }
        TCVelikClient.PostRelative("/api/share/SendVerificationEmail?OnboardingId=" + onboardingId + "&token=" + token + "&email=" + email).then(function (response) {
          if (response && response.status == 200) {
            if (response.data.existingUser != null) {
              instance.guestEmail = response.data.existingUser
              instance.isKnownUser = true
            }
            instance.$vs.loading.close()
            instance.InAuthorizationMode = true;
            instance.$vs.notify({
              title: instance.$t('CodeSentToEmail'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
          else if (response.status == 202) {
            if (response.data.existingUser != null) {
              instance.guestEmail = response.data.existingUser
              instance.isKnownUser = true
            }
            instance.$vs.loading.close()
            instance.InAuthorizationMode = true;
            instance.$vs.notify({
              title: instance.$t('CodeAlreadySent'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        }).catch(err => {
          instance.$vs.loading.close()
          alert(instance.$t('InvalidLink'))
        });
      },

      ResendEmail() {
        var instance = this
        TCVelikClient.PostRelative("/api/share/SendVerificationEmail?OnboardingId=" + this.$route.query.oid + "&token=" + instance.$route.query.token + "&forceEmailOnExistingToken=" + true).then(function (response) {
          if (response && response.status == 200) {
            instance.InAuthorizationMode = true;
            instance.$vs.notify({
              title: instance.$t('CodeSentToEmail'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('CodeSentToEmail'),
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      ValidatePIN(pin) {
        var instance = this
        TCVelikClient.PostRelative("/api/share/VerifyPIN?pin=" + pin + "&token=" + instance.$route.query.token).then(function (response) {
          if (response && response.status == 200) {
            instance.InAuthorizationMode = false;
            instance.GuestUserActions = true;
            localStorage.setItem(location.hostname +"-token", response.data.token);
            AccountService.refreshUser();
            instance.LoadOnboarding();
            let url = new URL(window.location.href);
            let token = url.searchParams.get("token");
            if (token) {
              url.searchParams.delete("token");
              history.pushState({}, '', url.href);
            }
          }
        }).catch(err => {
          instance.$vs.notify({
            text: instance.$t('InvalidPassword'),
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });

      },

      ShareOnboarding() {
        var instance = this;
        if (instance.shareReq.email == '' && instance.ShareType != "2") {
          instance.$vs.notify({
            title: instance.$t('FieldCannotBeEmpty'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
          return
        }
        TCVelikClient.PostRelative("/api/share/ShareOnboarding?OnboardingId=" + instance.shareReq.CurrentOnboarding.id + "&ToEmail=" + instance.shareReq.email + "&shareType=" + instance.ShareType + "&targetAudience=" + instance.shareReq.email)
          .then(function (response) {
            if (response && response.data && response.data.Success) {
              instance.onboardingLink = response.data.Link
              instance.InShareOnboardingMode = false;
              instance.AfterShare = true;
              instance.$vs.notify({
                title: instance.$t('Success'),
                text: instance.$t('OnboardingSharedSuccessfully'),
                color: "success",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
            }
            else if (response && response.data && response.data.errors) {
              alert(instance.$t('ErrorsSharingOnboarding'));
            }
          });
      },

      LoadSpaces(onboardingId, listName) {
        var instance = this;
        const query = `
        mutation LoadSpaces($onboardingId:Int!) {
          loadSpaces(onboardingId:$onboardingId) {
          id
          title
          description
          icon
          urlName,
          parentId
      }
      }
      `;
        const variables = {
          onboardingId: onboardingId * 1,
        }
        const req = {
          query,
          variables
        }
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data.data) {
            if (listName == "Spaces") {
              instance.tempSpaceList = response.data.data.loadSpaces
            }
            instance[listName] = response.data.data.loadSpaces.map(item => {
              return {
                ...item,               // Spread the existing properties of `item`
                breadcrumbTile: instance.GetBreadcrumb(item)   // Add the new property
              };
            });
          }

        });
      },
      AddOnboardingToSpace(space) {
        var instance = this;

        const query = `
  mutation AddToSpace($onboardingId:Int!,$spaceId:Int!) {
   addToSpace(onboardingId:$onboardingId,spaceId:$spaceId) {
        onboardingId
        spaceId
}
}
`;
        const variables = {
          onboardingId: instance.$route.query.oid * 1,
          spaceId: space[0].id
        }
        const req = {
          query,
          variables
        }
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data.data) {
            instance.$vs.notify({
              title: instance.$t('SuccessfullyAddedToSpace'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });

          }
          else {
            alert(instance.$t('ProblemAddingToSpace'))
          }

        });
      },

      RemoveOnboardingFromSpace(space) {
        var instance = this;

        const query = `
            mutation RemoveFromSpace($onboardingId:Int!,$spaceId:Int!) {
                 removeFromSpace(onboardingId:$onboardingId,spaceId:$spaceId) {
              }
          }`;

        const variables = {
          onboardingId: instance.$route.query.oid * 1,
          spaceId: space[0].id
        }
        const req = {
          query,
          variables
        }
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data.data) {
            instance.$vs.notify({
              title: instance.$t('SuccessfullyRemovedFromSpace'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
          else {
            instance.$vs.notify({
              title: instance.$t('ProblemRemovingFromSpace'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }

        });
      },

      OpenShareOnboarding() {
        this.InShareOnboardingMode = true
      },
      OpenAssignOnboarding() {
        this.InAssignOnboardingMode = true
      },

      OpenPropertiesMenu() {
        this.InPropertiesMenu = true;
      },

      UpdateUserPrefsForTour(value) {
        var instance = this;
        const query = `
   mutation UpdateUserPreference($value: String!, $key: String!) {
     updateUserPreference(key: $key, value: $value)
 }
 `;

        var variables = {
          key: "DisplayOnboradingDetailsTour",
          value: value
        };

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        })
      },

      sendLoginLink() {
        var instance = this;
        if (confirm(instance.$t('SendLoginLink'))) {
          TCVelikClient.PostRelative("/api/accounts/SendLoginLink?ToEmail=" + instance.guestEmail).then(function (response) {
            if (response) {
              instance.loginLink = response.data.Link;
              instance.AfterShare = true;
              instance.$vs.notify({
                title: instance.$t('LinkSent'),
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                time: 5000,
              });
            }
          }).catch(err => {
            instance.$vs.notify({
              title: instance.$t('ProblemSendingLink'),
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              time: 5000,
            });
          });
        }
        else {
          return;
        }
      },

      ImageSaved(img) {
        var instance = this
        this.CurrentZoomImage = img;
        this.CurrentImgDOM.src = img;

        var imageUrl = this.CurrentImgDOM.dataset["url"];

        TCVelikClient.PostRelative("/api/download/SaveImage", {
          ImageUrl: imageUrl,
          Base64: img
        }).then(function () {
          instance.$vs.notify({
            title: instance.$t('SuccessfullySavedImage'),
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
          instance.imageChanged = false;

        });
      },

      createAndBindButtons(container, isFirstParagraph = true, step_complete_visibility = false) {
        const instance = this;

        if (isFirstParagraph) {
          // Create complete button
          const completeButton = document.createElement("div");
          completeButton.innerHTML = `<button class="icon-button check text-success" title="${instance.$t('MarkStepCompleted')}"><i class="fas fa-check"></i></button>`;
          completeButton.querySelector(".icon-button").addEventListener("click", (e) => {
            e.stopPropagation()
            instance.HandleStepComeplete(container);
          });

          const copyButton = document.createElement("div");
          copyButton.innerHTML = `<button class="icon-button copy-clipboard code-only" title="${instance.$t('CopyToClipboard')}"><i class="fas fa-copy"></i></button>`;

          const fullscreenButton = document.createElement("div");
          fullscreenButton.innerHTML = `<button class="icon-button fullscreen-button code-only" title="${instance.$t('Fullscreen')}"><i class="fas fa-expand"></i></button>`;

          // Create flag and expand/collapse buttons
          const toolsContainer = document.createElement("div");
          toolsContainer.innerHTML =
            `<button class="icon-button chevron-down" title="${instance.$t('ExpandStepContents')}"><i class="fas fa-chevron-down expand-icon"></i></button>` +
            `<button class="icon-button chevron-up" title="${instance.$t('CollapseStepContent')}"><i class="fas fa-chevron-up expand-icon"></i></button>`
            ;

          toolsContainer.classList.add("right-tools");

          if (container.parentNode.getAttribute('data-subtype') == 'code') {
            toolsContainer.prepend(copyButton)
            toolsContainer.prepend(fullscreenButton)
          }

          if (!this.InDraftPage) {

            toolsContainer.innerHTML = `<button class="icon-button flag text-danger" title="${instance.$t('FlagThisStep')}"><i class="far fa-flag expand-icon"></i></button>` + toolsContainer.innerHTML

            toolsContainer.querySelector(".flag").addEventListener("click", (e) => {
              e.stopPropagation()
              instance.OpenAddCommentToStepMenu(container);
            });

            if (step_complete_visibility) {
              toolsContainer.prepend(completeButton)
            }

          }

          // Add buttons to container
          container.prepend(toolsContainer);


          toolsContainer.querySelector(".chevron-down").addEventListener("click", (e) => {
            e.stopPropagation()
            instance.toggleExpand(container);
          });

          toolsContainer.querySelector(".chevron-up").addEventListener("click", (e) => {
            e.stopPropagation()
            instance.toggleExpand(container);
          });


          if (container.parentNode.getAttribute('data-subtype') == 'code') {
            toolsContainer.querySelector(".copy-clipboard").addEventListener("click", (e) => {
              e.stopPropagation()
              instance.CopyCodeToClipboard(container.parentNode.getAttribute('data-step-id'));
            });

            toolsContainer.querySelector(".fullscreen-button").addEventListener("click", (e) => {
              e.stopPropagation()
              instance.OpenCodeInFullscreen(container.parentNode.getAttribute('data-step-id'));
            });
          }

        } else {
          // Create content action buttons
          const actionsContainer = document.createElement("div");
          actionsContainer.classList.add("content-actions");
          if (!this.InDraftPage) {
            actionsContainer.innerHTML = `
   <button class="vs-component vs-button vs-button-success vs-button-border main-body-step" title="${instance.$t('MarkStepCompleted')}">
     <i class="fas fa-check"></i>

   </button>
   <button class="vs-component vs-button vs-button-danger vs-button-border main-body-step" title="${instance.$t('FlagThisStep')}">
     <i class="far fa-flag"></i>

   </button>
 `;


            // Add buttons inside the content paragraph
            container.appendChild(actionsContainer);

            // Bind event handlers
            actionsContainer.querySelector(".vs-component.vs-button.vs-button-success.vs-button-border").addEventListener("click", () => {
              instance.toggleComplete(container.parentElement);
            });

            actionsContainer.querySelector(".vs-component.vs-button.vs-button-danger.vs-button-border").addEventListener("click", () => {
              instance.OpenAddCommentToStepMenu(container.parentElement);
            });
          }
        }
      },
      checkForFeedbackQuery() {
        const urlParams = new URLSearchParams(window.location.search);
        const rateParam = urlParams.get('rate');

        if (rateParam) {
          // Just open the feedback dialog
          this.InFeedbackMode = true;
        }
      },

      // New methods for presentation mode
      initializeParser() {
        console.log('initializeParser called, window.OnboardingParser:', !!window.OnboardingParser);

        if (typeof window !== 'undefined' && window.OnboardingParser) {
          this.parser = new window.OnboardingParser(this.getBaseUrl());
          console.log('Parser initialized successfully');
        } else {
          console.warn('OnboardingParser not available in window object');
          // Wait a bit and try again (script might still be loading)
          setTimeout(() => {
            console.log('Retry: window.OnboardingParser:', !!window.OnboardingParser);
            if (window.OnboardingParser) {
              this.parser = new window.OnboardingParser(this.getBaseUrl());
              console.log('Parser initialized on retry');
            } else {
              console.error('OnboardingParser failed to load');
            }
          }, 100);
        }
      },

      getBaseUrl() {
        // Get base URL from localStorage or current location
        return localStorage.getItem('CurrentTCVelikCloudUrl') || window.location.origin;
      },

      //COMPLETE BUTTON FUNCTIONALITY START

      checkForAnonymousCompletionBehavior(propsObj) {
        if (propsObj && propsObj.hasOwnProperty("AnonymousCompletionBehavior")) {
          if (typeof this[propsObj.AnonymousCompletionBehavior + "_cbFunction"] === 'function') {
            var res = this[propsObj.AnonymousCompletionBehavior + "_cbFunction"]()
            return res;
          }
        }

        if (this.$systemSettings && this.$systemSettings.hasOwnProperty("AnonymousCompletionBehavior")) {
          if (typeof this[this.$systemSettings.AnonymousCompletionBehavior + "_cbFunction"] === 'function') {
            var res = this[this.$systemSettings.AnonymousCompletionBehavior + "_cbFunction"]()
            return res;
          }
        }

        return this.PromptRegistration_cbFunction();
      },


      HandleStepComeplete(container) {
        var check = this.storedCheckFn()
        if (check == 1) {
          this.toggleComplete(container)
        }
        else if (check == 2) {
          this.storedCompleteFn = () => this.toggleComplete(container)
        }
        else if (check == 0) {
          return;
        }
      },

      CallCompleteButtonFunction() {
        this.storedCompleteFn();
      },

      HandleMarkCompletion() {
        var check = this.storedCheckFn()
        if (check == 1) {
          this.MarkAsCompletedForUser()
        }
        else if (check == 2) {
          this.storedCompleteFn = this.MarkAsCompletedForUser
        }
        else if (check == 0) {
          return;
        }
      },

      DoNotAllow_cbFunction() {
        this.allowCompleteButton = false
        return false;
      },

      Allow_cbFunction() {
        this.allowCompleteButton = true;
        this.storedCheckFn = () => { return true; }
        return true;
      },

      PromptRegistration_cbFunction() {
        this.allowCompleteButton = true;
        this.storedCheckFn = this.checkForAnonymousUser_reg
        return true;
      },

      AfterEmailVerification_cbFunction() {
        this.allowCompleteButton = true;
        this.storedCheckFn = this.checkForAnonymousUser_aev
        return true;
      },

      handleAnonymousEmailVerification(email) {
        var user = accountsService.getUserObjectFromLocalStorageSafe();
        user.User.Email = email
        localStorage.setItem(location.hostname + '-fullUserInfo', JSON.stringify(user));
        localStorage.setItem(location.hostname + "-anon_authed", true);
        this.InAnonymousEmailInputMode = false
        this.storedCompleteFn();
      },

      checkForAnonymousUser_reg() {
        if (this.$isAnonymous == true && localStorage.getItem(location.hostname + "-anon_authed") == null) {
          this.$vs.notify({
            title: this.$t('TrackHistoryRegisterFirst'),
            color: "warning",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
          return 0;
        }
        else {
          return 1;
        }
      },

      checkForAnonymousUser_aev() {
        if (this.$isAnonymous == true && localStorage.getItem(location.hostname + "-anon_authed") == null) {
          this.InAnonymousEmailInputMode = true
          return 2
        }
        else {
          return 1;
        }
      },

      //COMPLETE BUTTON FUNCTIONALITY END


      parseOnboardingData(rawContent, properties) {
        console.log('parseOnboardingData called with:', {
          hasParser: !!this.parser,
          rawContentLength: rawContent?.length || 0,
          properties: properties
        });

        if (!this.parser) {
          this.initializeParser();
        }

        if (this.parser) {
          try {
            this.parsedOnboardingData = this.parser.parseOnboarding(rawContent, properties);
            console.log('Parsed onboarding data:', this.parsedOnboardingData);
            console.log('Steps found:', this.parsedOnboardingData?.steps?.length || 0);
            return this.parsedOnboardingData;
          } catch (error) {
            console.error('Error parsing onboarding data:', error);
            // Fallback to empty data
            this.parsedOnboardingData = {
              steps: [],
              metadata: { totalSteps: 0 }
            };
            return this.parsedOnboardingData;
          }
        } else {
          console.warn('Parser not available, using fallback');
          // Fallback to empty data
          this.parsedOnboardingData = {
            steps: [],
            metadata: { totalSteps: 0 }
          };
          return this.parsedOnboardingData;
        }
      },

      // Slideshow methods
      exitSlideshow() {
        this.showSlideshow = false;
        this.presentationMode = false;
        // Update URL to remove mode parameter
        this.updateUrlWithMode('pdf');
      },

      onSlideChange(slideIndex) {
        console.log('Slide changed to:', slideIndex);
        // You can add analytics tracking here
      },

      onPresentationComplete() {
        console.log('Presentation completed');
        this.MarkAsCompletedForUser();
      },

      bindStepButtons() {
        // Re-bind step buttons after switching back to PDF mode
        this.$nextTick(() => {
          document.querySelectorAll("[data-type='draggable-item'] p:first-of-type")
            .forEach((titleContainer) => {
              this.createAndBindButtons(titleContainer, true);
            });

          document.querySelectorAll("[data-type='draggable-item'] p:nth-of-type(2)")
            .forEach((contentContainer) => {
              this.createAndBindButtons(contentContainer, false);
            });
        });
      },

      // Method to get current mode from URL
      getCurrentMode() {
        return this.$route.query.mode || 'pdf';
      },

      CopyCodeToClipboard(dataId) {
        var instance = this;
        var editor = this.$refs[`monacoEditor${dataId}`]

        // Check if editor exists before trying to access it
        if (!editor) {
          instance.$vs.notify({
            title: instance.$t('Error'),
            text: instance.$t('EditorNotFound'),
            color: "error",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
          return;
        }

        this.$copyText(editor.getValue()).then(
          function () {
            instance.$vs.notify({
              title: instance.$t('Success'),
              text: instance.$t('TextCopiedSuccessfully'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          })
      },

      OpenCodeInFullscreen(dataId) {
        const editorComponent = this.$refs[`monacoEditor${dataId}`]
        // Check if editor component exists before trying to access it
        if (!editorComponent) {
          this.$vs.notify({
            title: this.$t('Error'),
            text: this.$t('EditorNotFound'),
            color: "error",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
          return;
        }

        this.currentCode = editorComponent.getValue();

        this.InCodeFullsceenMode = true
      },

      OpenPresentationCodeInFullscreen(code) {
        this.currentCode = atob(code)
        this.InCodeFullsceenMode = true
      },

      // Add the missing AddCommentToStep method
      AddCommentToStep(comment) {
        var instance = this;
        var email = localStorage.getItem("pinUserEmail"); // if User with pin.
        if (!email || email.length == 0) {
          var email = JSON.parse(accountsService.getUserFromLocalStorage()).User.Email;
        }

        TCVelikClient.PostRelative("/api/analytics/OnboardingStep?OnboardingId=" + this.CurrentOnboarding.id + "&StepId=" + this.tempStepId + "&FeedbackType=1&Reason=" + comment + "&UserEmail=" + email).then(function (response) {
          if (response) {
            instance.$vs.notify({
              title: instance.$t('Success'),
              text: instance.$t('CommentAddedSuccessfully'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            instance.stepComment = '';
            instance.InAddingCommentToStepMode = false;
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ProblemSavingComment'),
            color: "failure",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        });
      },

      // Method to update URL with mode
      updateUrlWithMode(mode) {
        const currentQuery = { ...this.$route.query };
        if (mode === 'pdf') {
          delete currentQuery.mode;
        } else {
          currentQuery.mode = mode;
        }
        this.$router.replace({ query: currentQuery });
      },

      // Method to switch to slideshow mode
      switchToSlideshowMode() {
        // Update URL with slideshow mode
        this.updateUrlWithMode('slideshow');
        
        // The route watcher will handle the mode change and show slideshow
        // No need to manually set presentationMode or showSlideshow here
        // as the watcher will handle it automatically
      },

      // Fullscreen functionality for PDF mode
      toggleFullscreen() {
        if (!document.fullscreenElement) {
          document.documentElement.requestFullscreen()
          this.isFullscreen = true
        } else {
          document.exitFullscreen()
          this.isFullscreen = false
        }
      },

      setupFullscreenDetection() {
        document.addEventListener('fullscreenchange', this.handleFullscreenChange)
      },

      cleanupFullscreenDetection() {
        document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
      },

      handleFullscreenChange() {
        this.isFullscreen = !!document.fullscreenElement
      },

      // Image Editor scroll prevention methods
      handleImageEditorOpen() {
        
        // Prevent body scroll when image editor opens
        document.body.style.overflow = "hidden"
      },

      handleImageEditorClose() {
        // Restore body scroll when image editor closes
        document.body.style.overflow = "initial"
      }
    },
    components: {
      ImageEditor,
      FeatherIcon,
      ShareComponent,
      VxTour,
      DeleteOnboardingLink,
      MonacoEditor,
      vSelect,
      TabContainer,
      AssignComponent,
      FeedbackCard,
      OnboardingSlideshow,
      VerifyAnonymousEmail
    }
  }
</script>
<style>
  #external-container:has(#external-button:hover) #external-link {
    visibility: visible !important
  }

  .share-onboarding-popup .vs-popup {
    min-width: 800px !important;
  }

  /* Menu controls container */
  .menu-controls {
    display: flex;
    align-items: center;
    gap: 0;
  }

  /* Fullscreen button styles */
  .control-btn {
    width: 50px;
    height: 50px;
    background: rgba(255, 255, 255, 0.9);
    border: 2px solid #e2e8f0;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    flex-shrink: 0;
  }

    .control-btn:hover {
      background: rgba(255, 255, 255, 1);
      border-color: #cbd5e1;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      transform: translateY(-2px);
    }

    .control-btn i {
      font-size: 18px;
      color: #374151;
    }

    .control-btn:hover i {
      color: #1f2937;
    }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .control-btn {
      width: 40px;
      height: 40px;
    }

      .control-btn i {
        font-size: 16px;
      }
  }
</style>

